import { render, staticRenderFns } from "./HomeNavigationControl.vue?vue&type=template&id=071b444c&scoped=true&"
import script from "./HomeNavigationControl.vue?vue&type=script&lang=js&"
export * from "./HomeNavigationControl.vue?vue&type=script&lang=js&"
import style0 from "./HomeNavigationControl.vue?vue&type=style&index=0&id=071b444c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b444c",
  null
  
)

export default component.exports